<template>
	<el-button :type="type" :loading="loading" @click="Tijiao" :size="size" :plain="plain" :round="round" :circle="circle"
	 :disabled="disabled" :icon="icon" native-type="submit">{{text}}</el-button>
</template>

<script>
	export default {
		name: 'Tijiao',
		data() {
			return {
				loading: false,
				text: "提交"
			};
		},
		props: {
			wenzi: {
				type: String,
				default: "提交"
			},
			type: {
				type: String,
				default: "primary"
			},
			shijian: {
				type: Number,
				default: 2000
			},
			size: {
				type: String,
				default: ""
			},
			plain: {
				type: Boolean,
				default: false
			},
			round: {
				type: Boolean,
				default: false
			},
			circle: {
				type: Boolean,
				default: false
			},
			disabled: {
				type: Boolean,
				default: false
			},
			icon: {
				type: String,
				default: ''
			}
		},
		created() {
			this.text = this.wenzi;
		},
		methods: {
			Tijiao() {
				var that = this;
				this.loading = true;
				this.text = "执行中";
				setTimeout(function() {
					that.loading = false;
					that.text = that.wenzi;
				}, that.shijian)
				that.$emit("click")
			}
		}
	}
</script>
